import * as TypeGraphQL from "type-graphql";
export var SignalLineageScalarFieldEnum;
(function (SignalLineageScalarFieldEnum) {
    SignalLineageScalarFieldEnum["id"] = "id";
    SignalLineageScalarFieldEnum["timestamp"] = "timestamp";
    SignalLineageScalarFieldEnum["lineageId"] = "lineageId";
    SignalLineageScalarFieldEnum["signalId"] = "signalId";
    SignalLineageScalarFieldEnum["symbol"] = "symbol";
    SignalLineageScalarFieldEnum["signalType"] = "signalType";
    SignalLineageScalarFieldEnum["createdAt"] = "createdAt";
    SignalLineageScalarFieldEnum["generatorSource"] = "generatorSource";
    SignalLineageScalarFieldEnum["generatorVersion"] = "generatorVersion";
    SignalLineageScalarFieldEnum["inputSources"] = "inputSources";
    SignalLineageScalarFieldEnum["technicalIndicators"] = "technicalIndicators";
    SignalLineageScalarFieldEnum["llmAnalysis"] = "llmAnalysis";
    SignalLineageScalarFieldEnum["preAnalysisValidations"] = "preAnalysisValidations";
    SignalLineageScalarFieldEnum["filterResult"] = "filterResult";
    SignalLineageScalarFieldEnum["coordinationDecision"] = "coordinationDecision";
    SignalLineageScalarFieldEnum["executionOutcome"] = "executionOutcome";
    SignalLineageScalarFieldEnum["originalSignal"] = "originalSignal";
    SignalLineageScalarFieldEnum["finalSignal"] = "finalSignal";
    SignalLineageScalarFieldEnum["lifecycleEvents"] = "lifecycleEvents";
    SignalLineageScalarFieldEnum["performanceAttribution"] = "performanceAttribution";
    SignalLineageScalarFieldEnum["lastUpdated"] = "lastUpdated";
    SignalLineageScalarFieldEnum["storageLocation"] = "storageLocation";
    SignalLineageScalarFieldEnum["retentionDays"] = "retentionDays";
    SignalLineageScalarFieldEnum["complianceTags"] = "complianceTags";
    SignalLineageScalarFieldEnum["customTags"] = "customTags";
    SignalLineageScalarFieldEnum["executionStatus"] = "executionStatus";
    SignalLineageScalarFieldEnum["decisionType"] = "decisionType";
    SignalLineageScalarFieldEnum["pnlPercentage"] = "pnlPercentage";
    SignalLineageScalarFieldEnum["dataQuality"] = "dataQuality";
})(SignalLineageScalarFieldEnum || (SignalLineageScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SignalLineageScalarFieldEnum, {
    name: "SignalLineageScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SignalLineageScalarFieldEnum.js.map